import {
    ApplicationConfig,
    importProvidersFrom,
    inject,
    provideAppInitializer,
    provideBrowserGlobalErrorListeners,
    provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
    HTTP_INTERCEPTORS,
    HttpBackend,
    HttpClient,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { APP_BASE_HREF } from '@angular/common';
import { Interceptor } from './core/services/interceptor.service';
import { InitializationService } from './core/services/initialization.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import packageJson from 'package.json';
import { ComponentMessengerService } from './core/services/component-messenger.service';
import { RequestService } from './core/services/request.service';
import { PortalService } from './core/services/portal.service';
import { UserService } from './core/services/user.service';
import { PortalsResolveService } from './core/services/portals.resolve.service';
import { provideAnimations } from '@angular/platform-browser/animations';

export function initializationServiceFactory(provider: InitializationService) {
    return () => {
        return provider.init();
    };
}

export function HttpLoaderFactory(httpBackend: HttpBackend) {
    return new MultiTranslateHttpLoader(httpBackend, [
        { prefix: '/assets/i18n/', suffix: '.json?' + packageJson.version },
        { prefix: '/sb-tools/assets/i18n/', suffix: '.json?' + packageJson.version },
    ]);
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi()),
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient],
                },
            }),
            SimpleNotificationsModule.forRoot({
                position: ['bottom', 'right'],
                timeOut: 5000,
                lastOnBottom: true,
                showProgressBar: true,
                pauseOnHover: true,
            }),
            ModalModule.forRoot(),
        ),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: Interceptor,
            multi: true,
        },
        {
            provide: APP_BASE_HREF,
            useValue: '/',
        },
        provideAppInitializer(() => {
            const initializerFn = initializationServiceFactory(inject(InitializationService));
            return initializerFn();
        }),
        ComponentMessengerService,
        PortalService,
        UserService,
        RequestService,
        InitializationService,
        PortalsResolveService,
        provideAnimations(),
    ],
};
